/**
 * Recursively, change the value from another inside an object
 * @param obj Object
 * @param newVal New value
 * @param oldVal Old value
 */
export function changeValueInObject(obj: any, newVal: any, oldVal: any) {
  for (const k in obj) {
    if (obj.hasOwnProperty(k)) {
      if (typeof obj[k] === 'object') {
        changeValueInObject(obj[k], newVal, oldVal);
      } else {
        if (obj[k] === oldVal) {
          obj[k] = newVal;
        }
      }
    }
  }
}

/**
 * Maps linear point from a given scale to another linear value in a different scale
 * f(x) = ((value - inputMin) / (inputMax - inputMin)) * (outputMax - outputMin) + outputMin
 * @param value {Number} value in input scale
 */
export const linearToLinear = (
  value: number,
  inputMinValue: number,
  inputMaxValue: number,
  outputMinValue: number,
  outputMaxValue: number
): number => {
  return (
    (value - inputMinValue) /
      (inputMaxValue - inputMinValue) *
      (outputMaxValue - outputMinValue) +
    outputMinValue
  );
};

/**
 * Maps linear 0-1 point to logarithmic scale between min and max
 * f(0) = minValue
 * f(1) = maxValue
 * f(x) = (range + 1)^x + minValue
 * @param linearValue {Number} from 0 to 1 in linear scale
 */
export const linearToLogarithmic = (
  linearValue: number,
  minValue: number,
  maxValue: number
) => {
  const range = maxValue - minValue;
  let value = Math.pow(range + 1, linearValue) + minValue - 1;

  if (value < minValue) {
    value = minValue;
  } else if (value > maxValue) {
    value = maxValue;
  }

  return value;
};

/**
 * Maps a logarithmic value to a fractional point between 0-1 on the scale
 * g(minValue) = 0
 * g(maxValue) = 1
 * g(x) = log(base range + 1)(x)
 * @param value {Number}
 */
export const logarithmicToLinear = (
  value: number,
  minValue: number,
  maxValue: number
): number => {
  const range = maxValue - minValue;
  const normalizedValue = value - minValue + 1;

  if (normalizedValue <= 0) {
    return 0;
  } else if (value >= maxValue) {
    return 1;
  } else {
    return Math.log(normalizedValue) / Math.log(range + 1);
  }
};
